import React, { useCallback, useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { Alert, Button, Card, CardBody, CardFooter, Col, Progress, Row } from 'reactstrap';
import withRedirect from '../../helpers/hoc/withRedirect'
import FalconCardHeader from '../common/FalconCardHeader';
import Flex from '../common/Flex';
import { findOneSurvey, findOneSurveyResult } from '../../helpers/api/survey';
import { Message, Or, PreloadState } from '../UI/preloading/PreloadState';
import handleErrorMessage from '../../helpers/errors/handleErrorMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';

const ShowSurveys = () => {

    const history = useHistory();
    const { id } = useParams();

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [options, setOptions] = useState([]);
    const [totalVotes, setTotalVotes] = useState(0);
    const [survey, setSurvey] = useState(null);
    const [maxVotesOption, setMaxVotesOption] = useState(null);
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [dataError, setDataError] = useState(false);

    const loadSurvey = useCallback(
        () => {
            findOneSurvey(id)
                .then(({ data }) => {
                    setTitle(data?.voting_data.title);
                    setDescription(data?.details);
                    setSurvey(data?.voting_data.survey);
                    setOptions(data?.options);
                })
                .catch(error => handleErrorMessage(error));
            // eslint-disable-next-line 
        }, []);

    const loadResults = useCallback(() => {
        findOneSurveyResult(id)
            .then((data) => { setData(data) })
            .catch(error => { handleErrorMessage(error); setDataError(true); })
            .finally(() => setIsLoading(false));
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        loadSurvey();
        if (data) {
            setMaxVotesOption(getMaxIndex(data?.data?.map(({ count }) => count)));
            let total = data?.data?.reduce((n, { count }) => n + count, 0);
            setTotalVotes(total);
        }
        // eslint-disable-next-line
    }, [data]);

    useEffect(() => {
        if (id) loadResults()
        // eslint-disable-next-line
    }, [id])

    const getMaxIndex = (arr) => {
        if (arr.length === 0) { return -1 }
        var max = arr[0];
        var maxIndex = 0;
        for (var i = 1; i < arr.length; i++) {
            if (arr[i] > max) {
                maxIndex = i;
                max = arr[i];
            }
        }
        return maxIndex;
    }

    return <>
        <Card>
            <FalconCardHeader title={survey === 1 ? 'Resultados de la encuesta' : 'Resultados de la votación'} />
            <PreloadState cond={data ? true : false} loading={isLoading}>
                <Or value={true}>
                    <CardBody>
                        <Row>
                            <Col xs='auto'>
                                <span className='d-flex'>{survey === 1 ? 'Título de la encuesta:' : 'Título de la votación:'}</span>
                            </Col>
                            <Col>
                                <p><h5><b>{title}</b></h5></p>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs='auto'>
                                <span className='d-flex'>{survey === 1 ? 'Descripción de la encuesta:' : 'Descripción de la votación:'}</span>
                            </Col>
                            <Col>
                                <p className='font-weight-bolder'>{description}</p>
                            </Col>
                        </Row>
                        {survey === 1 ?
                            // eslint-disable-next-line 
                            options?.map(({ option, id }) => {
                                let value = null;
                                value = data?.data?.find((val) => val.id === id);
                                if (value) {
                                    let percentage = value.count > 0 ? (value.count / totalVotes) * 100 : 0;
                                    return (
                                        <Row key={id} className='mb-2'>
                                            <Col xs={3} md={12} lg={3} sm={12}>
                                                <p className='fs-1 font-weight-bold mb-0 text-sm-left text-md-left text-lg-right'>{option}</p>
                                            </Col>
                                            <Col>
                                                <Progress key={id} className='mb-3' style={{ height: '40px' }} value={percentage} ><p className='fs-1 font-weight-bold mb-0'>{percentage}%</p></Progress>
                                            </Col>
                                        </Row>
                                    )
                                }
                            })
                            :
                            <>
                                <span className='fs-1'>Opción elegida por la mayoría de propietarios:</span>
                                <Card className='bg-primary text-white mt-3' >
                                    <CardBody>
                                        <p className='fs-1 font-weight-bold mb-0'>• {options[maxVotesOption]?.option}</p>
                                    </CardBody>
                                </Card>
                            </>
                        }
                    </CardBody>
                    <CardFooter>
                        <Flex justify='end' align="center">
                            <Button color="light" onClick={() => history.push('/dashboard/surveys')} size="sm" className="px-5 mr-2" type="button">
                                Volver
                            </Button>
                        </Flex>
                    </CardFooter>
                </Or>
                <Or value={false}>
                    <PreloadState cond={dataError}>
                        <Or value={false}>
                            <Message value={false}>No hay datos para mostrar</Message>
                        </Or>
                        <Or value={true}>
                            <CardBody>
                                <Alert color='info'>
                                    <p className="mb-0"><FontAwesomeIcon icon={faExclamation} /> No se pueden ver los resultados, porqué la votación aún no ha concluído.</p>
                                </Alert>
                            </CardBody>
                            <CardFooter>
                                <Flex justify='end' align="center">
                                    <Button color="light" onClick={() => history.push('/dashboard/surveys')} size="sm" className="px-5 mr-2" type="button">
                                        Volver
                                    </Button>
                                </Flex>
                            </CardFooter>
                        </Or>
                    </PreloadState>
                </Or>
            </PreloadState>
        </Card>
    </>
}

export default withRedirect(ShowSurveys);